import apiFactory from '@/api/default';
const API = apiFactory('grips');

const state = {
  gripSearchResults: [],
  currentGrip: {},
};

const getters = {
  gripSearchResults: (state) => state.gripSearchResults,
  currentGrip: (state) => state.currentGrip,
};

const mutations = {
  setGripSearchResults: (state, gripSearchResults) => {
    state.gripSearchResults = gripSearchResults;
  },
  removeFromGripSearchResults: (state, id)=>{
    state.gripSearchResults.data = state.gripSearchResults.filter((obj)=>{
      return obj._id !== id;
    });
    state.gripSearchResults.total--;
  },
  setCurrentGrip: (state, currentGrip) => {
    state.currentGrip = currentGrip;
  },
};

const actions = {
  async searchGrips({commit}, name) {
    const response = await API.search(name);
    commit('setGripSearchResults', response.data);
    return response.data;
  },
  async loadGrip({commit}, id) {
    const response = await API.load(id);

    commit('setCurrentGrip', response.data);
    return response.data;
  },
  async createGrip({commit}, data) {
    const response = await API.create(data);
    return response.data;
  },
  async updateGrip(store, payload) {
    const response = await API.update(payload.id, payload.data);
    return response.data;
  },
  async confirmGripPoints(store, data) {
    const response = await API.confirmGripPoints(data);
    return response.data;
  },
  async deleteGrip({commit}, id) {
    const response = await API.remove(id);
    commit('removeFromGripSearchResults', id);
    return response;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
